export default "__VITE_ASSET__Cl4Zo89e__"